import _ from 'lodash';
import { FTProcessRowDimensions } from './FTProcessRowDimensions';
import { FTProcessRow } from '@/models/FTProcessRow';
import { goodsName } from '@/helpers/goodsName';

export class GoodsObject {
  _id: number | string;
  updatedAt?: string = undefined;
  createdAt?: string = undefined;
  densityUnit?: string = undefined;
  thickness?: number = undefined;
  density = 0;
  pcsPerKg = 0;
  color?: string = undefined;
  supGrade?: string = undefined;
  unitWeight = 0;
  rawMaterialUnit?: string = undefined;
  landedwarehouseprice?: number = undefined;
  form?: string = undefined;
  createdBy?: any = undefined;
  __v?: number = undefined;
  supplier?: {
    _id: number;
    name: string;
  } = undefined
  agent?: number = undefined;
  mainSpecification?: string = undefined;
  rawMaterialUWUnit?: string = undefined;
  linkedFrom?: any = [];  
  film?: {
    structure: Array<{ layer: string }>;
  } = undefined;
  paper?: {
    oba: number;
  } = undefined
  location?: {
    Factory: LocationData;
    Warehouse: LocationData;
  } = undefined;
  status?: string = undefined;
  dimensions?: FTProcessRowDimensions = undefined;
  category?: string = undefined;
  family?: string = undefined;
  type?: string = undefined;
  totalLength?: number = undefined;
  linearLength?: number = undefined;
  perKgRatio: { [key:string]: { value: number } } = {}
  psl?: any = {};
  ftProcessRow: FTProcessRow;
  __text = '';
  factoryTicket?: any;
  packingMode?: any[];
  static nameUpdateProps = ['dimensions', 'status', '_id'];
  static nameUpdatePrefix = '_nu_';

  constructor(goodsData: any, ftProcessRow: any) {
    Object.assign(this, goodsData);
    this._id = goodsData._id;
    this.ftProcessRow = ftProcessRow;
    this.updateText();
  }

  copyFrom(goodsObject: GoodsObject) {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const { _id, status, ftProcessRow, ...assignableGoodsObject } = goodsObject;
    Object.assign(this, assignableGoodsObject);
    this.supplier = _.cloneDeep(goodsObject.supplier);
    this.film = _.cloneDeep(goodsObject.film);
    this.paper = _.cloneDeep(goodsObject.paper);
    this.location = _.cloneDeep(goodsObject.location);
    this.dimensions = _.cloneDeep(goodsObject.dimensions);
    this.updateText();
  }

  setPerKgRatio(name: string, value: number) {
    this.perKgRatio = { ...this.perKgRatio, [name]: { value } };
  }

  updateText() {
    const processes = _.get(this.ftProcessRow, 'ftProcess.ftFactoryTicket.processes', null);
    this.__text = goodsName(this, processes);
  }

  toJSON() {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const { ftProcessRow, __text, ...allVars } = this;
    return allVars;
  }
}

interface LocationData {
  lastModified: string;
  availableQuantity: number;
  totalQuantity: number;
}
